export default "__VITE_ASSET__CQ81ntHU__"